module.exports = __webpack_public_path__ + "img/type--3-spans--multiple-lang--pt.709e0bec.jpg";